var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.time !== undefined)?_c('span',{staticClass:"text-muted"},[_vm._v("Computed in "+_vm._s(_vm.time)+" ms")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }